/// <amd-module name="Wit/BacklogsHub/BacklogSettings/Components/BacklogSettingsPanel" />
import { TeamContext } from "Tfs/Platform/Contracts/Core";
import { useTfsProject } from "Tfs/Platform/TfsComponent";
import { ObservableValue } from "VSS/Core/Observable";
import { Components, usePageContext } from "VSS/Platform/Layout";
import { IListBoxGroup } from "VSSUI/ListBox";
import { Observer } from "VSSUI/Observer";
import { IObservableAutomationRulesStatesViewData } from "Wit/BacklogsHub/BacklogSettings/Components/AutomationSettingsView/AutomationSettingsInterfaces";
import { getAutomationRulesSettings, getAutomationTab } from "Wit/BacklogsHub/BacklogSettings/Components/AutomationSettingsView/AutomationTab";
import { IBacklogSettingsPanelProps } from "Wit/BacklogsHub/BacklogSettings/Components/BacklogSettingsPanel.Props";
import { saveWorkItemAutomationRules } from "Wit/BacklogsHub/BacklogSettings/Utils/SaveSettingsUtil";
import { TeamSettingsPanel } from "Wit/Common/TeamSettingsPanel/Components/TeamSettingsPanel";
import { ITeamPermissions } from "Wit/Common/TeamSettingsPanel/Contracts/Contracts";
import { ITeamSettingsPanelService } from "Wit/Common/TeamSettingsPanel/Services/TeamSettingsPanelService";
import { ISettingsView } from "Wit/Common/WitSettingsPanelTypes/Components/WitSettingsPanel.props";
import * as React from "react";

export const BacklogSettingsPanel: React.FunctionComponent<IBacklogSettingsPanelProps> = ({ backlogSettingsData, onDismiss, onSave, teamId }) => {
    const pageContext = usePageContext();
    const project = useTfsProject();
    const teamSettingsPanelService = pageContext.getService<ITeamSettingsPanelService>("ITeamSettingsPanelService");

    return (
        <Observer backlogSettingsData={backlogSettingsData} permissions={teamSettingsPanelService.getTeamPermissions(teamId)}>
            {(props: { permissions: ITeamPermissions | undefined }) => {
                const { permissions } = props;

                if (!backlogSettingsData.value || !permissions) {
                    return null;
                }
                const disabled = !permissions?.CurrentUserHasTeamAdminPermission;

                const { automationRulesStates, backlogLevelName, teamName, teamId } = backlogSettingsData.value;

                const rulesSettings = getAutomationRulesSettings(automationRulesStates);

                const teamContext: TeamContext = {
                    teamId: teamId,
                    project: project?.name ?? "",
                    projectId: project?.id ?? "",
                    team: teamName
                };

                const observableViewSettingsData: IObservableAutomationRulesStatesViewData = {
                    isActiveEnabled: new ObservableValue(rulesSettings?.isActiveEnabled ?? false),
                    isCompletedEnabled: new ObservableValue(rulesSettings?.isCompletedEnabled ?? false),
                    isResolvedEnabled: new ObservableValue(rulesSettings?.isResolvedEnabled ?? false)
                };

                const settingsViews: ISettingsView[] = [
                    getAutomationTab(rulesSettings, observableViewSettingsData, disabled, BacklogSettingsGroup.Automation, () =>
                        saveWorkItemAutomationRules(pageContext, teamContext, observableViewSettingsData, backlogLevelName)
                    )
                ];
                return (
                    <TeamSettingsPanel
                        onDismiss={onDismiss}
                        onSave={onSave}
                        settingsGroups={settingsGroups}
                        settingsViews={settingsViews}
                        teamId={teamId}
                    />
                );
            }}
        </Observer>
    );
};

const BacklogSettingsGroup = {
    Automation: "automation"
};

const settingsGroups: IListBoxGroup[] = [
    {
        id: BacklogSettingsGroup.Automation,
        name: "Automation"
    }
];

Components.add("ms.vss-work-web.backlog-settings-panel-component", BacklogSettingsPanel);
